import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_virtual } from '@shared/dto/grid2d_virtual/DTO__grid2d_virtual';
import { useVirtualizer } from '@tanstack/react-virtual';
import { useRef } from 'react';
import { HOOK_GRID2D__masonry_cell_heights } from './HOOK_GRID2D__masonry_cell_heights';

export function HOOK_GRID2D__float_virtualizer(
  grid2d_virtual: DTO__grid2d_virtual,
  grid2d: DTO__grid2d,
  //
  ref_grid: HTMLDivElement | null,
  ui_grid2d_cells_sort_newest_first: boolean,
  max_side: number,
) {
  const ref_item_heights = useRef<number[]>([]);

  let virtualizer = useVirtualizer({
    count: grid2d.total_cells_amount,
    getScrollElement: () => ref_grid,
    estimateSize: i => ref_item_heights.current[i],
    lanes: grid2d_virtual.total_columns,
    overscan: grid2d_virtual.total_columns * 10,
    gap: CONSTANTS__client.FLOAT_GRID_GAP,
  });

  const { try_recalculate_item_heights } = HOOK_GRID2D__masonry_cell_heights({
    grid2d_virtual,
    ref_item_heights,
    grid2d,
    ui_grid2d_cells_sort_newest_first,
    max_side,
    virtualizer,
  });

  return { virtualizer, try_recalculate_item_heights };
}
